import { createApp } from 'vue';
import App from './App.vue';
import router from "./router";
import AOS from 'aos';
import 'aos/dist/aos.css';
import i18n from './i18n';

// Store
import store from "./state/store"; // ⚠️ Ancien Vuex store (si nécessaire)
import { createPinia } from "pinia";

// Librairies UI
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';

import BootstrapVueNext from 'bootstrap-vue-next';
import vClickOutside from "click-outside-vue3";
import VueApexCharts from "vue3-apexcharts";
import { vMaska } from "maska";

import VueFeather from 'vue-feather';

// Styles
import '@/assets/scss/config/default/app.scss';
import "leaflet/dist/leaflet.css";
import '@/assets/scss/mermaid.min.css';
import 'bootstrap/dist/js/bootstrap.bundle';
import '@vueform/multiselect/themes/default.css'

// Initialisation AOS
AOS.init({
    easing: 'ease-out-back',
    duration: 1000
});

const app = createApp(App);
const pinia = createPinia();

// Configuration BootstrapVueNext pour éviter les erreurs de render
app.use(BootstrapVueNext, {
  components: true,
  directives: true
});

// ✅ PATCH pour éviter l'erreur "addEventListener on null" dans les dropdowns Bootstrap
// Ce code s'exécute après le montage de l'application
const originalAddEventListener = window.addEventListener;
window.addEventListener = function(type, listener, options) {
  // Vérifier que le document.body existe avant d'ajouter des listeners globaux
  if (type === 'click' && !document.body) {
    // Stocker le listener pour l'ajouter plus tard
    if (!window._pendingListeners) window._pendingListeners = [];
    window._pendingListeners.push({ type, listener, options });
    return null;
  }
  return originalAddEventListener.call(this, type, listener, options);
};

// Ajouter les listeners en attente après le chargement du DOM
document.addEventListener('DOMContentLoaded', () => {
  if (window._pendingListeners) {
    window._pendingListeners.forEach(({ type, listener, options }) => {
      originalAddEventListener.call(window, type, listener, options);
    });
    delete window._pendingListeners;
  }
});

// ✅ Gestionnaire d'erreurs global pour capturer et ignorer les erreurs connues
app.config.errorHandler = (err, instance, info) => {
  // Ignorer l'erreur spécifique "addEventListener on null"
  if (err && err.message && err.message.includes('addEventListener')) {
    console.warn('⚠️ Erreur Bootstrap ignorée (addEventListener):', err.message);
    return; // Ne pas propager l'erreur
  }
  
  // Pour les autres erreurs, les logger normalement
  console.error('❌ Vue error:', err);
  console.error('Info:', info);
};

// ✅ Patch pour les composants Bootstrap spécifiques
// Cette fonction sera appelée après le montage de l'application
app.mixin({
  mounted() {
    // Attendre que le DOM soit prêt
    this.$nextTick(() => {
      // Correction pour les dropdowns Bootstrap
      const dropdowns = document.querySelectorAll('[data-bs-toggle="dropdown"]');
      dropdowns.forEach(dropdown => {
        if (dropdown && !dropdown.hasAttribute('data-bs-popper')) {
          try {
            // Initialisation manuelle si nécessaire
            dropdown.setAttribute('data-bs-popper', 'static');
          } catch (e) {
            // Ignorer
          }
        }
      });
    });
  }
});

window.$app = app

// Installation des plugins
app.use(store)          // ⚠️ Vuex (si tu veux garder l'ancien store)
   .use(pinia)          // ✅ Pinia
   .use(router)
   .use(VueApexCharts)
   .component(VueFeather.type, VueFeather)
   .directive("maska", vMaska)
   .use(i18n)
   .use(VueSweetalert2)
   .use(vClickOutside);

// ✅ Monter l'application après un petit délai pour s'assurer que le DOM est prêt
setTimeout(() => {
  app.mount('#app');
}, 0); // Délai 0 = juste après la fin du cycle actuel